import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { LegalPersonalityEnum } from 'src/app/domain/enums/legal-personality.enum';
import { ContributorTypeEnum } from 'src/app/domain/registration/enums/contributor-type.enum';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { FiscalEnvironmentEnum } from 'src/app/domain/registration/enums/fiscal-environment.enum';
import { RegimeTypeEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { PartnerIndexSelectComponent } from '../partners/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'customers';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'code',
  'document',
  'name',
  'city',
  'tradingName',
  'cellPhone',
  'isContractGenerated',
  'isContractSigned',
  'createdAt',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    link_show: true,
    field_type: FieldTypeEnum.LABEL,
    property: 'code',
    display: 'CÓDIGO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    link_show: true,
    field_type: FieldTypeEnum.IMAGE,
    property: 'image',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'document',
    display: 'CPF / CNPJ',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'Cliente',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    maxLength: 25
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'city',
    display: 'Cidade',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    maxLength: 25
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'tradingName',
    display: 'Fantasia',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    maxLength: 25
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'stateRegistration',
    display: 'IE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'municipalRegistration',
    display: 'Incr. Municipal',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'typeContributor',
    display: 'Tipo Contribuinte',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'cellPhone',
    display: 'Celular',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'phone',
    display: 'Telefone',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'email',
    display: 'E-mail',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'webSite',
    display: 'Web Site',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'isContractGenerated',
    display: 'C.: Gerado',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'isContractSigned',
    display: 'C.: Assinado',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'updatedAt',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },  


];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    label: 'ÁTIVO',
    name: 'isActive',
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
  },
  // sessao - 1
  // imagem - image
  {
    name: 'image',
    type: TypeComponentFieldEnum.IMAGE,
  },
  // codigo - input
  {
    label: 'CÓDIGO',
    name: 'code',
    type: TypeComponentFieldEnum.INPUT,
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'legalPersonality',
    value: LegalPersonalityEnum.PESSOA_FISICA,
    options: Object.values(LegalPersonalityEnum),
  },
  // cpf / cnpj - input
  {
    label: 'CPF',
    name: 'cpf',
    type: TypeComponentFieldEnum.INPUT_CPF,
    validation: [Validators.required, Validators.minLength(11)],
  },
  // cpf / cnpj - input
  {
    label: 'CNPJ',
    name: 'cnpj',
    type: TypeComponentFieldEnum.INPUT_CNPJ,
    validation: [Validators.required, Validators.minLength(14)],
  },
  // razão social - input
  {
    label: 'NOME',
    name: 'name',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    label: 'DATA DE NASCIMENTO',
    name: 'birthday',
    type: TypeComponentFieldEnum.INPUT_DATE,
    validation: [],
  },

  //remover após alterar a data de cadastro dos clientes já existentes
  {
    name: 'createdAt',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
    validation: [],
  },

  {
    name: 'updatedAt',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
    validation: [],
  },

  // razão social - input
  {
    label: 'RAZÃO SOCIAL',
    name: 'companyName',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  // fantasia - input
  {
    label: 'FANTASIA',
    name: 'tradingName',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  // rg - input
  {
    label: 'RG',
    name: 'generalRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    validation: [Validators.required, Validators.pattern(/\d+/)],
  },
  // ie - input
  {
    label: 'IE',
    name: 'stateRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
  },
  // incr. municipal - number
  {
    label: 'INCR. MUNICIPAL',
    name: 'municipalRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
  },
  // regime - select
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO CONTRIBUINTE',
    name: 'contributorType',
    value: ContributorTypeEnum.CONTRIBUTOR,
    options: Object.values(ContributorTypeEnum),
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  // celular - input phone
  {
    label: 'CELULAR',
    name: 'cellPhone',
    type: TypeComponentFieldEnum.INPUT_CELLPHONE,
    validation: [Validators.required, Validators.minLength(11)],
  },
  // telefone - input phone
  {
    label: 'TELEFONE',
    name: 'phone',
    type: TypeComponentFieldEnum.INPUT_PHONE,
  },
  {
    label: 'EMAIL',
    name: 'email',
    type: TypeComponentFieldEnum.INPUT_EMAIL,
    validation: [Validators.required, Validators.minLength(14)],
  },
  // web site - input
  {
    label: 'WEB SITE',
    name: 'webSite',
    type: TypeComponentFieldEnum.INPUT,
  },
  // contrato - input
  {
    label: 'CONTRATO',
    name: 'contract',
    type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
  },
  // contractComment - input
  {
    label: 'COMENTÁRIO',
    name: 'contractComment',
    type: TypeComponentFieldEnum.INPUT,
  },
  // contractDate - date
  {
    label: 'DATA',
    name: 'contractDate',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
  },
  {
    label: 'ASSINADO EM',
    name: 'signedAt',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
  },
  // licença - input
  {
    label: 'LICENÇA',
    name: 'license',
    type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
  },
  // licenseComment - input
  {
    label: 'COMENTÁRIO',
    name: 'licenseComment',
    type: TypeComponentFieldEnum.INPUT,
  },
  // licenseDate - date
  {
    label: 'DATA',
    name: 'licenseDate',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
  },
  // sessao - 3
  {
    type: TypeComponentFieldEnum.INPUT_CEP,
    label: 'CEP',
    name: 'cep',
    placeholder: 'Insira o CEP',
    validation: [Validators.required, Validators.minLength(7)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'ENDEREÇO',
    name: 'address',
    placeholder: 'Insira o endereço',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'COMPLEMENTO',
    name: 'addressComplement',
    placeholder: 'Insira o complemento se houver',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Nº',
    name: 'addressNumber',
    placeholder: 'Insira o número caso houver',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'BAIRRO',
    name: 'neighborhood',
    placeholder: 'Insira o bairro',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'UF',
    name: 'state',
    placeholder: 'Insira a UF do estado',
    options: [],
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'CIDADE',
    name: 'city',
    placeholder: 'Insira o nome da cidade',
    validation: [],
    options: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'OBSERVAÇÃO',
    name: 'addressObservation',
    placeholder: 'Insira uma observação',
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'CÓDIGO EXTERNO',
    name: 'externalCode',
    placeholder: 'Insira o código externo',
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'QUANTIDADE DE ACESSOS',
    name: 'accessQuantity',
    placeholder: 'Insira a quantidade de acessos',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'PAÍS',
    name: 'country',
    placeholder: 'Insira o pais',
    validation: [],
  },

  // consultant - select crud
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: null,
    componentData: { params: { isConsultant: true } },
    label: 'CONSULTOR',
    name: 'consultant',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },


  // consultantCommission - input percent
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO',
    name: 'consultantCommission',
    placeholder: 'Insira a comissão do consultor',
    validation: [],
  },

  // partner - select crud
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: null,
    componentData: { params: { isPartner: true } },
    label: 'PARCEIRO',
    name: 'partner',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO',
    name: 'partnerCommission',
    placeholder: 'Insira a comissão do parceiro',
    validation: [],
  },

  // representative - select crud
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: null,
    componentData: { params: { isRepresentative: true } },
    label: 'REPRESENTANTE',
    name: 'representative',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  // representativeCommission - input percent
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO',
    name: 'representativeCommission',
    placeholder: 'Insira a comissão do representante',
    validation: [],
  },

  // counter - select crud
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: null,
    componentData: { params: { isCounter: true } },
    label: 'CONTADOR',
    name: 'counter',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  // counterCommission - input percent
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO',
    name: 'counterCommission',
    placeholder: 'Insira a comissão do contador',
    validation: [],
  },

  // unit - select crud
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: null,
    componentData: { params: { isUnit: true } },
    label: 'UNIDADE',
    name: 'unit',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  // unitCommission - input percent
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO',
    name: 'unitCommission',
    placeholder: 'Insira a comissão da unidade',
    validation: [],
  },

  // sessao - 5
  // regime - select
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'REGIME',
    name: 'regime',
    value: RegimeTypeEnum.SIMPLE,
    options: Object.values(RegimeTypeEnum),
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  // atividade principal - input
  {
    label: 'ATIVIDADE',
    name: 'mainActivity',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  // ambiente fiscal - select
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'AMBIENTE FISCAL',
    name: 'fiscalEnvironment',
    options: Object.values(FiscalEnvironmentEnum),
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  // CSC
  {
    label: 'CSC',
    name: 'csc',
    type: TypeComponentFieldEnum.INPUT,
  },
  // ID CSC
  {
    label: 'ID CSC',
    name: 'cscId',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
  },
  // certificado digital - input
  {
    label: 'CERTIFICADO DIGITAL',
    name: 'digitalCertificate',
    type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
  },
  // digitalCertificateComment - input
  {
    label: 'COMENTÁRIO',
    name: 'digitalCertificateComment',
    type: TypeComponentFieldEnum.INPUT,
  },
  // digitalCertificateDate - date
  {
    label: 'DATA',
    name: 'digitalCertificateDate',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
  },
  {
    label: 'ÚLTIMO BACKUP',
    name: 'lastBackup',
    type: TypeComponentFieldEnum.INPUT_FILE_WITH_COMMENT_AND_DATE,
  },
  {
    label: 'COMENTÁRIO',
    name: 'lastBackupComment',
    type: TypeComponentFieldEnum.INPUT,
  },
  // lastBackupDate - date
  {
    label: 'DATA',
    name: 'lastBackupDate',
    type: TypeComponentFieldEnum.INPUT_DATETIME,
  },
];
